export default "__VITE_ASSET__0jusMhvP__"